import * as React from 'react';

type LogoProps = {
    width?: number;
    height?: number;
    className?: string;
};

const LogoIcon: React.FC<LogoProps> = ({width = 32, height = 32, className}) => {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 15C0 6.70673 6.67464 0 15 0C23.2536 0 30 6.70673 30 15C30 23.2933 24.1148 30 15 30C5.88517 30 0 23.2933 0 15Z"
                fill="#214495"
            />
            <path
                d="M22.2488 23.3653C23.6124 21.9951 23.6124 19.8317 22.2488 18.4615L18.8038 14.9999L22.2488 11.5384C23.6124 10.1682 23.6124 8.00474 22.2488 6.63455C20.8852 5.26435 18.6603 5.26435 17.3684 6.63455L13.6364 10.3845C14.4976 9.51916 15.933 9.51916 16.7943 10.3845C17.6555 11.2499 17.6555 12.6922 16.7943 13.5576L15.3589 14.9999L16.7943 16.4422C17.6555 17.3076 17.6555 18.7499 16.7943 19.6153C15.933 20.4807 14.4976 20.4807 13.6364 19.6153L17.3684 23.3653C18.7321 24.6634 20.9569 24.6634 22.2488 23.3653Z"
                fill="#FFCB32"
            />
            <path
                d="M9.04308 15L13.6364 10.3846V9.08657C13.6364 7.21157 12.0574 5.62503 10.1914 5.62503C8.25361 5.62503 6.74643 7.21157 6.74643 9.08657V20.8414C6.74643 22.7164 8.32538 24.3029 10.1914 24.3029C12.1292 24.3029 13.6364 22.7164 13.6364 20.8414V19.5433L9.04308 15Z"
                fill="#22C2F2"
            />
            <path
                d="M15.3588 15L16.7942 13.5577C17.6555 12.6923 17.6555 11.25 16.7942 10.3846C15.933 9.51922 14.4976 9.51922 13.6363 10.3846L9.04305 14.9279L13.6363 19.4711C14.4976 20.3365 15.933 20.3365 16.7942 19.4711C17.6555 18.6058 17.6555 17.1634 16.7942 16.2981L15.3588 15Z"
                fill="white"
            />
        </svg>
    );
};

export default LogoIcon;
